var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "matrix-checkbox mt-20"
  }, [_c('div', {
    staticClass: "option-title"
  }, [_c('div', {
    staticClass: "question-title"
  }), _vm.children[0].options ? _c('div', {
    staticClass: "matrix-checkbox-option-item"
  }, _vm._l(_vm.children[0].options, function (option) {
    return _c('div', {
      key: option.option_id,
      staticClass: "ant-checkbox-wrapper"
    }, [_vm._v(_vm._s(option.title))]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "matrix-checkbox-value"
  }, _vm._l(_vm.children, function (item, index) {
    return _c('div', {
      key: item.question_id,
      staticClass: "question-item"
    }, [_c('span', {
      staticClass: "question-title"
    }, [_vm._v(_vm._s(item.title))]), item.options ? _c('a-checkbox-group', {
      on: {
        "change": _vm.handleChange
      },
      model: {
        value: _vm.value[index].option_id_list,
        callback: function ($$v) {
          _vm.$set(_vm.value[index], "option_id_list", $$v);
        },
        expression: "value[index].option_id_list"
      }
    }, _vm._l(item.options, function (option) {
      return _c('a-checkbox', {
        key: option.option_id,
        attrs: {
          "value": option.option_id
        }
      });
    }), 1) : _vm._e()], 1);
  }), 0)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };